import { makeStyles } from '@material-ui/core';
import { PREINFORME_COLORS } from '../../constants/preinformeColors';

/**
 * Estilos compartidos por la cabecera y las tarjetas de la vista de
 * preinforme. Local a esta vista: no extiende GraficasStyles.js (lo usa
 * hitorialUser.js) ni el tema global (src/app/config/**, blocked).
 */
const preinformeStyles = makeStyles((theme) => ({
    // Cabecera de solo lectura
    headerPaper: {
        padding: theme.spacing(3),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${PREINFORME_COLORS.border}`,
    },
    headerTopRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderBottom: `1px solid ${PREINFORME_COLORS.border}`,
    },
    headerIdentity: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
    },
    headerAvatar: {
        width: theme.spacing(6),
        height: theme.spacing(6),
        borderRadius: theme.spacing(1.5),
        backgroundColor: PREINFORME_COLORS.blue,
        color: '#ffffff',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    headerName: {
        fontWeight: 800,
        color: PREINFORME_COLORS.dark,
    },
    headerRightText: {
        textAlign: 'right',
    },
    metaLabel: {
        color: PREINFORME_COLORS.textMuted,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        fontSize: '0.65rem',
        fontWeight: 700,
        display: 'block',
    },
    metaValue: {
        fontWeight: 700,
        color: PREINFORME_COLORS.dark,
    },
    // Sección de métricas
    sectionTitle: {
        fontWeight: 700,
        color: PREINFORME_COLORS.dark,
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
    },
    emptyMetricas: {
        color: PREINFORME_COLORS.textMuted,
        marginBottom: theme.spacing(2),
    },
    // Tarjeta de métrica y de valor
    card: {
        height: '100%',
        padding: theme.spacing(2.5),
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${PREINFORME_COLORS.border}`,
        borderTopWidth: 4,
        borderTopStyle: 'solid',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    cardAtenuada: {
        opacity: 0.6,
    },
    cardHeaderRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
    },
    cardTitulo: {
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
        fontSize: '0.7rem',
        color: PREINFORME_COLORS.textMuted,
    },
    cardChip: {
        fontWeight: 700,
        color: '#ffffff',
        height: theme.spacing(2.5),
    },
    valueRow: {
        display: 'flex',
        alignItems: 'baseline',
        gap: theme.spacing(0.75),
    },
    valueNumber: {
        fontWeight: 800,
        color: PREINFORME_COLORS.dark,
        fontSize: '1.75rem',
        lineHeight: 1,
    },
    valueUnit: {
        fontWeight: 700,
        color: PREINFORME_COLORS.textMuted,
    },
    referencia: {
        color: PREINFORME_COLORS.textMuted,
    },
    nota: {
        color: PREINFORME_COLORS.textMuted,
    },
    // Barra de rangos
    barraContainer: {
        position: 'relative',
        height: theme.spacing(1),
        borderRadius: theme.spacing(0.5),
        overflow: 'hidden',
        display: 'flex',
        backgroundColor: PREINFORME_COLORS.surface,
    },
    tramo: {
        height: '100%',
    },
    marcador: {
        position: 'absolute',
        top: -2,
        width: 2,
        height: theme.spacing(1) + 4,
        backgroundColor: PREINFORME_COLORS.dark,
    },
    // Tarjeta narrativa (oportunidades, fortalezas, recomendaciones)
    narrativaCard: {
        height: '100%',
        padding: theme.spacing(2.5),
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${PREINFORME_COLORS.border}`,
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
    },
    narrativaTitulo: {
        fontWeight: 700,
        color: PREINFORME_COLORS.dark,
    },
    narrativaCuerpo: {
        color: PREINFORME_COLORS.textMuted,
        lineHeight: 1.6,
        whiteSpace: 'pre-line',
        marginTop: theme.spacing(1),
    },
    narrativaBadge: {
        width: theme.spacing(3),
        height: theme.spacing(3),
        minWidth: theme.spacing(3),
        borderRadius: '50%',
        backgroundColor: PREINFORME_COLORS.blue,
        color: '#ffffff',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.8rem',
    },
    narrativaHeaderRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    // Panel de metas sugeridas a 12 semanas
    metasPanel: {
        background: `linear-gradient(135deg, ${PREINFORME_COLORS.darkPanelStart} 0%, ${PREINFORME_COLORS.darkPanelMid} 50%, ${PREINFORME_COLORS.darkPanelEnd} 100%)`,
        color: '#ffffff',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(3.5),
        marginTop: theme.spacing(3),
    },
    metasTitulo: {
        fontWeight: 700,
        color: '#ffffff',
        marginBottom: theme.spacing(2),
    },
    metaItem: {
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        height: '100%',
    },
    metaLabelPanel: {
        color: PREINFORME_COLORS.cyanLight,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        fontSize: '0.7rem',
        fontWeight: 700,
        display: 'block',
    },
    metaValor: {
        fontWeight: 800,
        color: '#ffffff',
        fontSize: '1.4rem',
        marginTop: theme.spacing(0.5),
    },
    // Fila de acciones de la cabecera (Volver / Ver informe PDF / Descargar PDF)
    headerActionsCol: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: theme.spacing(1),
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center',
            width: '100%',
        },
    },
    headerActionsRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: theme.spacing(1.5),
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
            width: '100%',
        },
    },
    buttonNoTransform: {
        textTransform: 'none',
    },
    actionsSpinner: {
        marginLeft: theme.spacing(0.5),
    },
    // Aviso de advertencias
    avisoBox: {
        backgroundColor: PREINFORME_COLORS.warningBg,
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
        borderLeftColor: PREINFORME_COLORS.severidad[2],
        padding: theme.spacing(2),
        borderRadius: theme.spacing(1),
        marginTop: theme.spacing(3),
    },
    avisoTexto: {
        color: PREINFORME_COLORS.dark,
    },
    // Tarjetas de mediciones (feature 20)
    cardClasificacion: {
        fontWeight: 700,
        color: PREINFORME_COLORS.dark,
        overflowWrap: 'anywhere',
    },
    filasList: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    filaRow: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'baseline',
        columnGap: theme.spacing(1),
        rowGap: theme.spacing(0.25),
        minWidth: 0,
    },
    filaEtiqueta: {
        fontWeight: 700,
        color: PREINFORME_COLORS.textMuted,
        fontSize: '0.8rem',
        minWidth: theme.spacing(10),
    },
    filaValor: {
        fontWeight: 800,
        color: PREINFORME_COLORS.dark,
    },
    filaClasificacion: {
        color: PREINFORME_COLORS.textMuted,
        overflowWrap: 'anywhere',
    },
}));

export default preinformeStyles;
